import template from './createSubcontractModal.html';
import controller from './createSubcontractModal.controller';

let CreateSubcontractModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

export default CreateSubcontractModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/createSubcontractModal/createSubcontractModal.component.js